/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18.4431 1.4687c.4105.3112.7254.7774.8496 1.3984l2.1207 10.6038a.7743.7743 0 0 0 .7592.6223h1.0532a.7742.7742 0 1 1 0 1.5484h-1.0532c-1.1071 0-2.0604-.7814-2.2775-1.8671L17.7744 3.1708a.8615.8615 0 0 0-.0425-.1456c-.267-.6795-1.3165-.6333-1.4752.1422l-3.8575 18.8588a2.126 2.126 0 0 1-.0125.058c-.5534 2.4364-4.0753 2.391-4.545-.0917L5.3637 8.8944c-.0788-.4163-.4147-.6269-.7527-.6303h-.008c-.1967-.0002-.3691.0606-.4905.1518-.1067.0802-.2175.2144-.2687.4706l-.5131 2.5655c-.2171 1.0856-1.1704 1.867-2.2775 1.867H0a.7742.7742 0 1 0 0-1.5484h1.0532a.7741.7741 0 0 0 .7592-.6223l.513-2.5655c.5006-2.5027 4.0852-2.484 4.5596.0237l2.478 13.0982c.0485.2559.1575.3912.2634.4727.121.0932.2938.1561.4916.1576.1979.0014.3717-.059.494-.1503.1071-.08.2181-.2137.2703-.4688l3.8574-18.8588a2.6614 2.6614 0 0 1 .05-.2036C15.2762.9632 17.2579.57 18.4431 1.4686Z"
    clipRule="evenodd"
  />,
  'Frequency'
);
